(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zeta-tour-register"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.zeta-tour-register').forEach(function (root) {
    var form = root.querySelector('.zeta-tour-register__form');
    if (!form) return;

    var successPanel = form.querySelector('[data-tour-success]');
    var errorPanel = form.querySelector('[data-tour-error]');
    var submitBtn = form.querySelector('.zeta-tour-register__submit');

    var field = function (name) {
      var el = form.elements['contact[' + name + ']'];
      return el && el.value ? el.value.trim() : '';
    };

    var subscribeToKlaviyo = function () {
      if (!root.dataset.klaviyoCompany || !root.dataset.klaviyoList) return null;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: root.dataset.klaviyoSource || 'Landing page',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: field('email'),
                  first_name: field('first_name'),
                  last_name: field('last_name'),
                  properties: {
                    'Tour Preferred City': field('preferred_city'),
                    'Tour Seats': field('seats'),
                    'Tour Notes': field('body')
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: root.dataset.klaviyoList }
            }
          }
        }
      };

      return fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.klaviyoCompany),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify(payload)
        }
      );
    };

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.classList.contains('is-submitted')) return;

      if (errorPanel) errorPanel.hidden = true;
      var originalLabel = '';
      if (submitBtn) {
        originalLabel = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.dataset.sendingLabel || 'Sending…';
      }

      var contactRequest = fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' }
      });
      var klaviyoRequest = subscribeToKlaviyo();

      var primary = klaviyoRequest || contactRequest;
      if (klaviyoRequest) contactRequest.catch(function () {});

      primary
        .then(function (response) {
          if (!response.ok) throw new Error('submission failed');
          form.classList.add('is-submitted');
          if (successPanel) {
            successPanel.hidden = false;
            successPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
            successPanel.focus({ preventScroll: true });
          }
        })
        .catch(function () {
          if (errorPanel) {
            errorPanel.hidden = false;
            errorPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
